// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ErrorPanel_dropdown__230PS","head":"ErrorPanel_head__2lQOG","info":"ErrorPanel_info__2mC4U"};